import firepng from "./fire.png"
import { Sprite, Container, Graphics } from "pixi.js"

// let fireLevel = 22
export let fire = Sprite.from(firepng)
fire.anchor.set(0.5, 0.5)

fire.x = 0
fire.y = 10

let fireContainer = new Container()
let mask = new Graphics()
    .beginFill()
    .drawRect(0 - 6, 0 + 24, 12, 24)
    .endFill()

fireContainer.mask = mask
fireContainer.addChild(mask)
fireContainer.addChild(fire)



export default fireContainer 